import { api } from '../../../services/api'

/**
 * Get image upload URL.
 *
 * @endpoint POST /api/me/image_upload
 * @scope shared
 * @see https://flecto.dev/api-4724204
 */
export async function getImageUploadUrl(): Promise<GetImageUploadUrlResponse> {
  const { data } = await api.post('/api/me/image_upload')

  return data
}

export type GetImageUploadUrlResponse = {
  id: string
  upload_url: string
}
